import { render, staticRenderFns } from "./createBiker.vue?vue&type=template&id=06570532&scoped=true&"
import script from "./createBiker.vue?vue&type=script&lang=js&"
export * from "./createBiker.vue?vue&type=script&lang=js&"
import style0 from "./createBiker.vue?vue&type=style&index=0&id=06570532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06570532",
  null
  
)

export default component.exports